import type { SearchAction, WebSite, WithContext } from "schema-dts";
import type { StoreConfig } from "../store-config/context/types";

type Props = {
	storeConfig: StoreConfig;
};

// query-input is not supported by schema-dts so we need to extend the type
// https://github.com/google/schema-dts/issues/33
type SearchActionWithQueryInput = SearchAction & {
	"query-input": string;
};

export const WebSiteJsonLd = ({ storeConfig }: Props) => {
	const searchAction: SearchActionWithQueryInput = {
		"@type": "SearchAction",
		target: `${storeConfig.metadata.productionUrl}/search?q={search_term}`,
		"query-input": "required name=search_term",
	};

	const jsonLd: WithContext<WebSite> = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: storeConfig.metadata.siteName,
		url: `${storeConfig.metadata.productionUrl}`,
		potentialAction: searchAction,
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
		/>
	);
};
